import React, { createContext, useContext } from "react";

import { PdfGenerator } from "../../../../../components";
import InvoiceHeader from "./Invoice/InvoiceHeader";
import InvoiceContent from "./Invoice/InvoiceContent";
import InvoiceFooter from "./Invoice/InvoiceFooter";
import TableHeader from "./Invoice/TableHeader";
import InvoiceData from "./Invoice/InvoiceData";
/////////////////
import logo from "../../../../../assets/images/headerLogo.svg";

const InvoiceGenerator = () => {
  const data = {
    company: {
      name: "TekTree LLC",
      address: "1106 Drummond Plaza, DE 19711",
      contact: "+1 (123) 456-7890",
      email: "accounts@tektreeinc.com",
      website: "www.tektreeinc.com",
      companyLogo: logo,
      additionalInfo: `This Invoice has been Sold & Assigned to Tek Tree LLC Remit payment only to: P.O Box #799, Gloucester, VA - 23061, C/O Chesapeake Bank, Chesapeake Bank`,
    },
    invoiceDeta: {
      name: "Shubha Minds LLC",
      address:
        "10520 Chapell Hill road, #156, Morrisville, North California, United States, 27560",
      invoiceNumber: "25100010",
      invoiceDate: "2023-10-10",
      shippedDate: "2023-10-15",
      netTerms: "Net 30",
      dueDate: "2023-10-20",
      invoicedItems: [
        {
          item: "Product A",
          description: "High-quality product A",
          quantity: 2,
          price: 50,
          discount: 0,
        },
        {
          item: "Product B",
          description: "High-quality product B",
          quantity: 5,
          price: 186,
          discount: 10,
        },
        {
          item: "Product C",
          description: "High-quality product C",
          quantity: 16,
          price: 48,
          discount: 2,
        },
        {
          item: "Product D",
          description: "High-quality product D",
          quantity: 55,
          price: 16,
          discount: 0,
        },
        {
          item: "Product E",
          description: "High-quality product E",
          quantity: 45,
          price: 18,
          discount: 0,
        },
        {
          item: "Product E",
          description: "High-quality product E",
          quantity: 45,
          price: 18,
          discount: 0,
        },
        {
          item: "Product E",
          description: "High-quality product E",
          quantity: 45,
          price: 18,
          discount: 0,
        },
      ],
    },
  };

  const total = data.invoiceDeta.invoicedItems.reduce(
    (sum, item) => sum + (item.quantity * item.price - (item.discount || 0)),
    0
  );

  const updatedData = {
    ...data,
    invoiceDeta: {
      ...data?.invoiceDeta,
      totalDue: total,
      currency: "USD",
    },
  };

  return (
    <div className="flex-1 w-full h-full overflow-auto">
      <PdfGenerator
        // initialPageSize="a4"
        // initialLayout="portrait"
        data={updatedData}
        items={updatedData.invoiceDeta.invoicedItems}
        header={<InvoiceHeader data={updatedData} />}
        headerTwo={<InvoiceHeader data={updatedData} type="sub" />}
        contentTop={<InvoiceContent data={updatedData} type="top" />}
        contentBottom={<InvoiceContent data={updatedData} type="bottom" />}
        tableHeader={<TableHeader />}
        rowRenderer={(item, index) => InvoiceData(item, index)}
        footer={<InvoiceFooter data={updatedData} />}
        footerTwo={<InvoiceFooter data={updatedData} type="sub" />}
        backgroundLogo={logo}
        fileName={`Invoice-omkar-${updatedData.invoiceDeta.invoiceNumber}`}
      />
    </div>
  );
};

export default InvoiceGenerator;
